import type { ReactNode } from "react";
import { BehaviorNodeCard } from "../BehaviorNodeCard.js";

export interface OperatorNodeCardProps {
  children: ReactNode;
}

export const OperatorNodeCard = ({ children }: OperatorNodeCardProps) => {
  return (
    <BehaviorNodeCard>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 0",
        }}
      >
        {children}
      </div>
    </BehaviorNodeCard>
  );
};
